export const getTodayFormatted = () => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  };

// Affiche "DD/MM/YYYY" à partir d'une ISO string ou "YYYY-MM-DD ..."
export const formatDateShort = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
};
